import React from 'react';
import './product-offer-selection.css';
import { Product } from 'core/types/api/Api';

interface IProductOfferSelection {
    productOffer: Product,
    isSelected: boolean,
    onSelectionChange: (val: number) => void,
    disabled?: boolean,
}

export const ProductOfferSelection = ({
    productOffer,
    onSelectionChange,
    isSelected,
    disabled = false,
} : IProductOfferSelection) => (
    <div className={`fi-product-offer${disabled ? ' product-disabled' : ''}`}>
        <button
            disabled={disabled}
            type="button"
            className={`fi-product-offer-selection ${isSelected ? 'fi-product-offer-selection--selected' : ''}`}
            onClick={() => onSelectionChange(productOffer?.id as number)}
        >
            <span className="fi-product-offer-selection__name">{productOffer.name}</span>
        </button>
        <p className="fi-product-offer-selection__description">
            {productOffer.description && productOffer.description.split('\n')
                .map((item) => (
                    <span key={item?.replaceAll(' ', '_')}>
                        {item}
                    </span>
                ))}
        </p>
    </div>
);
